export const appsAppGroupIdChartsSessionsLifetimeStats = "/apps/:app_group_id/charts/sessions/lifetime_stats";
